import React from 'react';
import ReactLoading from 'react-loading';

const LoadingOverlay = ({ isVisible }) => {
  if (!isVisible) return null; // Don't render anything if not visible

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <ReactLoading type="spin" color="#ffffff" height={50} width={50} /> {/* Customize type and color as needed */}
    </div>
  );
};

export default LoadingOverlay;